<template>
  <!-- modified with tooltip and new icon-->
  <responsive-drawer-header
    :color="color"
    :headerBg="theme.appBar.other.bg"
    :badgeColor="theme.unreadBadgeColor"
    :badgeCount="0"
    :moduleUnreadCount="0"
    :hasDrawer="isWebLinkGroup"
    :isItemDisplayed="!!currentWeblinkItem"
  >
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      <div v-if="dataLoaded" class="d-flex">{{ $t('weblinks.headerDrawer.title') }}</div>
      <div v-else class="d-flex">
        {{ $t('loading') }}
      </div>
    </template>
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div v-if="dataLoaded && isWebLinkGroup && currentWeblinkItem">
        <div>{{ currentWeblinkItem.title }} {{ currentWeblinkItem.url }}</div>
      </div>
      <div v-else-if="dataLoaded && !isWebLinkGroup && currentWeblinkItem" class="d-flex">
        {{ currentWeblinkItem.title }} {{ currentWeblinkItem.url }}
      </div>
      <div v-else-if="dataLoaded" class="d-flex">
        {{ $t('weblinks.noUrlSelected') }}
      </div>
      <div v-else-if="!dataLoaded">
        {{ $t('loading') }}
      </div>
    </template>
    <template v-slot:right>
      <v-btn class="mr-sm-5 mr-1" :color="theme.appBar.other.color" text x-small rounded @click="back()">
        <v-icon class="mr-0 pr-0">mdi-chevron-left</v-icon>
        {{ $t('back') }}
      </v-btn>
    </template>
  </responsive-drawer-header>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerHeader from '../../layouts/ResponsiveDrawerHeader.vue';
import MODULE_ID from './moduleId';
import index from './index';
import { mapState } from 'vuex';

export default {
  name: 'WeblinkHeader',
  mixins: [common, configMixin, dateTimeMixin],
  components: { ResponsiveDrawerHeader },

  computed: {
    ...mapState(MODULE_ID, ['dataLoaded', 'currentWeblinkItem']),

    color() {
      return this.theme.appBar.other.color;
    },

    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance); //mixin
    },
    isWebLinkGroup() {
      return this.moduleConfig ? this.moduleConfig.isWebLinkGroup === true : false;
    },
  },
  methods: {
    /** Back to news base view */
    back() {
      this.$router.push('/');
    },
  },
};
</script>
